import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import * as _ from "lodash";
import ErrorMessage from "../common/ErrorMessage";
import { OVEN_TYPE_SELECT } from "../../constance/dataTypes";
import { Form, Button, Radio, Space ,InputNumber} from "antd";
import ColorButton from "../common/ColorButton";
import { BLUE_COLOR } from "../../constance/color";
import { CheckOutlined } from "@ant-design/icons";


export default function SelectOvenType(props) {
  const {
    onSelectOven,
    onSelectOvenSetMenu,
    onBack,
  } = props;

  const { t } = useTranslation();
  const ovenNoRef = React.useRef();
  const [form] = Form.useForm();

  const [errorMessages, setErrorMessages] = React.useState(null);
  const oven = Form.useWatch('ovens', form)
  const ovenType = Form.useWatch('ovenType', form)

  const isOvenValid = ovenType !== OVEN_TYPE_SELECT.SPECIFIC || (typeof oven === 'number' && !isNaN(oven));
  const onSelect = async () => {
    await form.validateFields();
    if (!ovenType) {
      setErrorMessages(t('error_messages.validation.required'))
      return;
    }
    setErrorMessages(null);

    switch (ovenType) {
      case OVEN_TYPE_SELECT.ALL:
        onSelectOven([]);
        return;
      case OVEN_TYPE_SELECT.SPECIFIC:
        onSelectOven([oven]);
        return;
      case OVEN_TYPE_SELECT.SET:
        onSelectOvenSetMenu();
        return;

    }
  }

  return (
    <div>
      <ErrorMessage message={errorMessages} />

      <Form form={form}>
        <div style={{ width: 'fit-content', margin: 'auto', textAlign: 'left' }}>
          <Form.Item name={'ovenType'}>
            <Radio.Group
              value={ovenType}>
              <Space direction="vertical">
                <Radio value={OVEN_TYPE_SELECT.ALL}>
                  {t('post_baking_waste_wood_count.all_oven')}
                </Radio>
                <Radio value={OVEN_TYPE_SELECT.SPECIFIC}>
                  <Space>
                    {`${t('post_baking_waste_wood_count.specific_oven')} ${t('post_baking_waste_wood_count.oven_no')}`}
                    <Form.Item name={'ovens'}
                      rules={[{
                        required: ovenType === OVEN_TYPE_SELECT.SPECIFIC,
                        message: ''
                      }]}>
                      <InputNumber
                        style={{ width: '70px', marginTop: '24px' }}
                        ref={ovenNoRef}
                        placeholder={t('input')} />
                    </Form.Item>
                  </Space>
                </Radio>
                <Radio value={OVEN_TYPE_SELECT.SET}>
                  {t('post_baking_waste_wood_count.oven_set')}
                </Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </div>
        <Space>
          <ColorButton type="primary" override={BLUE_COLOR} onClick={() => onSelect()} disabled={!isOvenValid} icon={<CheckOutlined />} >{t('confirm')}</ColorButton>
          <Button variant="filled" color="default" onClick={onBack} >{t('back')}</Button>
        </Space>
      </Form>


    </div>
  )
}

SelectOvenType.propTypes = {
  onSelectOven: PropTypes.func,
  onSelectOvenSetMenu: PropTypes.func,
  onBack: PropTypes.func,
}

SelectOvenType.defaultProps = {
  onSelectOven: () => null,
  onSelectOvenSetMenu: () => null,
  onBack: () => null,
}